/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./divider-panel.component.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./divider-panel.component";
var styles_DividerPanelComponent = [i0.styles];
var RenderType_DividerPanelComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_DividerPanelComponent, data: {} });
export { RenderType_DividerPanelComponent as RenderType_DividerPanelComponent };
export function View_DividerPanelComponent_0(_l) { return i1.ɵvid(0, [i1.ɵqud(671088640, 1, { panelEl: 0 }), (_l()(), i1.ɵeld(1, 0, [[1, 0], ["panelEl", 1]], null, 0, "div", [["class", "divider-panel"]], null, null, null, null, null))], null, null); }
export function View_DividerPanelComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-divider-panel", [], null, null, null, View_DividerPanelComponent_0, RenderType_DividerPanelComponent)), i1.ɵdid(1, 4374528, null, 0, i2.DividerPanelComponent, [], null, null)], null, null); }
var DividerPanelComponentNgFactory = i1.ɵccf("app-divider-panel", i2.DividerPanelComponent, View_DividerPanelComponent_Host_0, { data: "data" }, {}, []);
export { DividerPanelComponentNgFactory as DividerPanelComponentNgFactory };
